import { createFileRoute } from '@tanstack/react-router'
import { LibraPage } from 'pages/libra/LibraPage'

export const Route = createFileRoute('/libra/')({
  component: LibraPage,
  staticData: {
    title: 'Libra',
  },
})
